import { render } from "./TocList.vue?vue&type=template&id=4553f9b6"
import script from "./TocList.vue?vue&type=script&lang=js"
export * from "./TocList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__